import type { IconSvgObject } from './types';

const Jsx03Icon: IconSvgObject = [
  ["path", { d: "M15.6618 14L13.4916 14V16.5H15.6618V19H13.4916M11 14V17.5C11 18.3284 10.3284 19 9.5 19C8.67157 19 8 18.3284 8 17.5V17M21 19L19.5 16.5M19.5 16.5L18 14M19.5 16.5L21 14M19.5 16.5L18 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 22H5C3.89543 22 3 21.1046 3 20L3 4C3 2.89543 3.89543 2 5 2H12L19 9V11M18.5 9H13.998C12.8935 9 11.998 8.10457 11.998 7V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Jsx03Icon;
